
export const getTransactions = async (from, to) => {

    const res = await fetch(`/api/transactions?dateFrom=${from}&dateTo=${to}`);
    if (!res.ok) throw new Error("Помилка запиту транзакцій");
    return res.json();
};

export const updateTransactionCategory = async (id, update) => {
    const res = await fetch(`/api/transactions/${id}`, {
        method: "PATCH",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(update),
    });

    if (!res.ok) throw new Error("Помилка оновлення категорії");
    return res.json();
};

export const updateTransaction = async (txId, updatedFields) => {
    const res = await fetch(`/api/transactions/${txId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedFields),
    });
    if (!res.ok) throw new Error("Помилка оновлення транзакції");
    return await res.json();
};

export const deleteTransaction = async (txId) => {
    const res = await fetch(`/api/transactions/${txId}`, {
        method: "DELETE",
    });
    if (!res.ok) throw new Error("Помилка видалення транзакції");
    return await res.json();
};

/* ================= CATEGORY RULES ================= */

export async function fetchCategoryRules() {
    const res = await fetch("/api/category-rules/admin", {
        credentials: "include",
    });
    if (!res.ok) throw new Error("Помилка завантаження правил");
    return res.json();
}

export async function createCategoryRule(payload) {
    const res = await fetch("/api/category-rules/admin", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    return res.json();
}

export async function updateCategoryRule(ruleId, payload) {
    const res = await fetch(`/api/category-rules/admin/${ruleId}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify(payload),
    });
    return res.json();
}

export async function deleteCategoryRule(ruleId) {
    const res = await fetch(`/api/category-rules/admin/${ruleId}`, {
        method: "DELETE",
        credentials: "include",
    });
    return res.json();
}

export async function recategorizePeriod(from, to) {
    const res = await fetch("/api/category-rules/recategorize", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({ from, to }),
    });
    return res.json();
}



